"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateServiceCompany = exports.useCreateServiceCompany = exports.useServiceCompanyByName = exports.useServiceCompany = exports.useServiceCompanies = void 0;
const react_1 = require("react");
const mutations_1 = require("../graphql/mutations");
const queries_1 = require("../graphql/queries");
const amplifyBootstrap_1 = require("../utils/amplifyBootstrap");
const useServiceCompanies = (filter) => {
    const [serviceCompanies, setServiceCompanies] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        fetchServiceCompanies();
    }, [filter]);
    const fetchServiceCompanies = async () => {
        try {
            setLoading(true);
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.listServiceCompanies,
                variables: { limit: 100 },
                authMode: 'userPool',
            });
            if (response && response.data) {
                let items = [];
                if (Array.isArray(response.data.listServiceCompanies)) {
                    items = response.data.listServiceCompanies;
                }
                else if (response.data.listServiceCompanies &&
                    Array.isArray(response.data.listServiceCompanies.items)) {
                    items = response.data.listServiceCompanies.items;
                }
                else if (response.data.listServiceCompanies) {
                    items = [response.data.listServiceCompanies];
                }
                setServiceCompanies(items);
            }
            else {
                console.warn('Unexpected API response structure:', response);
                setServiceCompanies([]);
            }
            setError(null);
        }
        catch (err) {
            setError(err);
            console.error('Error fetching service companies:', err);
        }
        finally {
            setLoading(false);
        }
    };
    const refetch = () => {
        fetchServiceCompanies();
    };
    return { serviceCompanies, loading, error, refetch };
};
exports.useServiceCompanies = useServiceCompanies;
const useServiceCompany = (initialId) => {
    const [id, setId] = (0, react_1.useState)(initialId);
    const [serviceCompany, setServiceCompany] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (id) {
            fetchServiceCompany();
        }
    }, [id]);
    const fetchServiceCompany = async () => {
        if (!id) {
            console.warn('Cannot fetch service company: No ID provided');
            return null;
        }
        try {
            setLoading(true);
            setError(null);
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.getServiceCompany,
                variables: { id },
                authMode: 'userPool',
            });
            if (response && response.data && response.data.getServiceCompany) {
                setServiceCompany(response.data.getServiceCompany);
                return response.data.getServiceCompany;
            }
            else {
                console.warn('Unexpected API response structure:', response);
                setServiceCompany(null);
                return null;
            }
        }
        catch (err) {
            setError(err);
            console.error('Error fetching service company:', err);
            return null;
        }
        finally {
            setLoading(false);
        }
    };
    return { serviceCompany, loading, error, fetchServiceCompany, setId };
};
exports.useServiceCompany = useServiceCompany;
const useServiceCompanyByName = (name) => {
    const [serviceCompany, setServiceCompany] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (name) {
            fetchServiceCompany();
        }
    }, [name]);
    const fetchServiceCompany = async () => {
        try {
            setLoading(true);
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.listServiceCompanies,
                variables: { limit: 100 },
                authMode: 'userPool',
            });
            if (response && response.data && response.data.listServiceCompanies) {
                let items = [];
                if (Array.isArray(response.data.listServiceCompanies)) {
                    items = response.data.listServiceCompanies;
                }
                else if (response.data.listServiceCompanies &&
                    Array.isArray(response.data.listServiceCompanies.items)) {
                    items = response.data.listServiceCompanies.items;
                }
                const foundServiceCompany = items.find((c) => c.name === name);
                setServiceCompany(foundServiceCompany || null);
            }
            else {
                console.warn('Unexpected API response structure:', response);
                setServiceCompany(null);
            }
            setError(null);
        }
        catch (err) {
            setError(err);
            console.error('Error fetching service company by name:', err);
        }
        finally {
            setLoading(false);
        }
    };
    return { serviceCompany, loading, error };
};
exports.useServiceCompanyByName = useServiceCompanyByName;
const useCreateServiceCompany = () => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const create = async (input) => {
        try {
            setLoading(true);
            setError(null);
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.createServiceCompany,
                variables: { input },
                authMode: 'userPool',
            });
            if (response && response.data && response.data.createServiceCompany) {
                return response.data.createServiceCompany;
            }
            else {
                console.warn('Unexpected API response structure:', response);
                return null;
            }
        }
        catch (err) {
            setError(err);
            console.error('Error creating service company:', err);
            return null;
        }
        finally {
            setLoading(false);
        }
    };
    return { create, loading, error };
};
exports.useCreateServiceCompany = useCreateServiceCompany;
const useUpdateServiceCompany = () => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const update = async (input) => {
        try {
            setLoading(true);
            setError(null);
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.updateServiceCompany,
                variables: { input },
                authMode: 'userPool',
            });
            if (response && response.data && response.data.updateServiceCompany) {
                return response.data.updateServiceCompany;
            }
            else {
                console.warn('Unexpected API response structure:', response);
                return null;
            }
        }
        catch (err) {
            setError(err);
            console.error('Error updating service company:', err);
            return null;
        }
        finally {
            setLoading(false);
        }
    };
    return { update, loading, error };
};
exports.useUpdateServiceCompany = useUpdateServiceCompany;
